import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import Footer from "../components/Footer";
import EditableImage from "../components/EditableImage";
import EmailGate from "../components/EmailGate";
import RichText from "../components/RichText";
import { HANDLE, SLUGS } from "../config";
import { getT } from "../i18n/translations";

const H2 = ({ children }) => (
  <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 12px" }}>{children}</h2>
);

const P = ({ children, italic }) => (
  <p style={{ margin: "0 0 12px", color: "var(--ink-soft)", fontStyle: italic ? "italic" : "normal" }}>
    {children}
  </p>
);

const Bullet = ({ text }) => (
  <li style={{ marginBottom: 8, color: "var(--ink)" }}>
    <RichText text={text} />
  </li>
);

export default function About({ lang }) {
  const navigate = useNavigate();
  const a = getT(lang).about;
  const [gateOpen, setGateOpen] = useState(false);

  return (
    <div className="portal" data-testid="about-page">
      <BrandHeader />

      {/* Card 1 — O meni */}
      <div className="card fade-up" data-testid="about-intro-card">
        <EditableImage
          storageKey="about-portrait"
          label="PHOTO 3 — portrait"
          style={{ width: "100%", height: 230 }}
          data-testid="about-photo"
        />
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: "16px 0 12px" }}>{a.pageTitle}</h1>
        <P>{a.intro1}</P>
        <p style={{ margin: 0, color: "var(--ink-soft)" }}>
          {a.intro2.map((line, i) => (
            <span key={i} style={{ display: "block" }}>
              <RichText text={line} />
            </span>
          ))}
        </p>
      </div>

      {/* Card — Moj Put */}
      <div className="card fade-up" data-testid="about-path-card">
        <H2>{a.path.heading}</H2>
        <P>{a.path.p1}</P>
        <P>{a.path.p2}</P>
        <p style={{ margin: "0 0 12px", fontWeight: 700 }}>{a.path.bold}</p>
        <P>{a.path.p3}</P>
        <EditableImage
          storageKey="about-conference"
          label="PHOTO — conference panel"
          style={{ width: "100%", height: 180, marginTop: 8 }}
          data-testid="about-conference-photo"
        />
      </div>

      {/* Card — Šta radim danas */}
      <div className="card fade-up" data-testid="about-today-card">
        <EditableImage
          storageKey="about-blockchain-panel"
          label="PHOTO — Blockchain World panel"
          style={{ width: "100%", height: 180, marginBottom: 18 }}
          data-testid="about-blockchain-photo"
        />
        <H2>{a.today.heading}</H2>
        <P>{a.today.intro}</P>
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          {a.today.bullets.map((b) => (
            <Bullet key={b} text={b} />
          ))}
        </ul>
        <p style={{ margin: 0, fontStyle: "italic", color: "var(--ink-soft)" }}>
          {a.today.closing.map((line, i) => (
            <span key={i} style={{ display: "block" }}>
              {line}
            </span>
          ))}
        </p>
      </div>

      {/* Card — Vrednosti */}
      <div className="card fade-up" data-testid="about-values-card">
        <H2>{a.values.heading}</H2>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {a.values.bullets.map((b) => (
            <Bullet key={b} text={b} />
          ))}
        </ul>
      <EditableImage
        storageKey="about-award"
        label="PHOTO — award ceremony"
        className="fade-up"
        style={{ width: "100%", marginTop: 16 }}
        data-testid="about-award-photo"
      />
      </div>

      {/* Card — Moja Misija */}
      <div className="card fade-up" data-testid="about-mission-card">
        <H2>{a.mission.heading}</H2>
        <p style={{ margin: 0, color: "var(--ink-soft)" }}>
          <RichText text={a.mission.text} />
        </p>
      <EditableImage
        storageKey="about-rooftop"
        label="PHOTO — rooftop pool, city panorama"
        className="fade-up"
        style={{ width: "100%", marginTop: 16 }}
        data-testid="about-rooftop-photo"
      />
      </div>

      {/* Card — Lična Strana */}
      <div className="card fade-up" data-testid="about-personal-card">
        <H2>{a.personal.heading}</H2>
        <p style={{ margin: "0 0 12px", color: "var(--ink-soft)" }}>
          {a.personal.p1.map((line, i) => (
            <span key={i} style={{ display: "block" }}>
              {line}
            </span>
          ))}
        </p>
        <p style={{ margin: 0, color: "var(--ink-soft)" }}>
          <RichText text={a.personal.p2} />
        </p>
      <EditableImage
        storageKey="about-travel"
        label="PHOTO — travel crowd"
        className="fade-up"
        style={{ width: "100%", marginTop: 16 }}
        data-testid="about-travel-photo"
      />
      </div>

      {/* Bottom nav */}
      <nav className="card fade-up" style={{ display: "flex", flexDirection: "column", gap: 12 }} data-testid="about-nav">
        <button className="btn" data-testid="about-hub" onClick={() => setGateOpen(true)}>
          {a.nav.hub}
        </button>
        <button
          className="btn"
          data-testid="about-contact"
          onClick={() => navigate(`/${lang}/${SLUGS[lang].contact}`)}
        >
          {a.nav.contact}
        </button>
        <button className="btn btn-primary" data-testid="about-back" onClick={() => navigate(`/${lang}`)}>
          {a.nav.back}
        </button>
      </nav>

      <footer style={{ textAlign: "center", fontWeight: 600, paddingTop: 4 }} data-testid="about-footer">
        {HANDLE}
      </footer>

      <EmailGate lang={lang} open={gateOpen} onClose={() => setGateOpen(false)} />
    </div>
  );
}
